import React from 'react';
import styles from '../../styles/rca/RCASearch.module.scss';

const RCANextSteps = (props) => {
    const {steps} = props;


    return (
        steps.map ( (step, i)=> {
            const opacityClass = (i == 1 ? styles.secondStep : (i==2 ? styles.thirdStep : ''));
            return ( 
                <div className={`${styles.boxWrapper} ${styles.nextStep} ${opacityClass} mb-3`} key={i}>
                    {step}
                </div>
            );
        })
    );

}

export default RCANextSteps;